<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="级别名称">
                <el-input v-model="queryForm.agentName"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getMppAgentLevelList">查询
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addMppAgentLevel"
                    >新建
                    </el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editMppAgentLevel(null)"
                    >修改
                    </el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteMppAgentLevel(null)"
                    >删除
                    </el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
                    <span
                        class="icon-box"
                        @click="refreshMppAgentLevelList"
                    >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                height='100%'
                :data="mppAgentLevelList"
                row-key="id"
                border
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="agentName"
                    label="级别名称"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="agentLevel"
                    label="级别数值"
                    width="180"
                >
                    <!-- <template scope='scope'>
                        <div>{{getLevelString(scope.row.agentLevel)}}</div>
                    </template> -->
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="weight"
                    label="级别权重"
                    width="180"
                >
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="agentMoney"
                    label="级别费用"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="agentLogo"
                    label="代理logo"
                    width="180"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.agentLogo'>
                            <el-image
                                @click='updateSrcList(scope.row.agentLogo)'
                                style="width: 30px; height: 30px"
                                :src="scope.row.agentLogo"
                                :preview-src-list="srcList"
                            ></el-image>
                        </div>
                        <div v-else>--</div>
                    </template>


                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="agentRatio"
                    label="级别比例"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="scoreRatio"
                    label="积分比例"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="discount"
                    label="级别折扣"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="scoreDiscount"
                    label="积分折扣"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="distributionRatio"
                    label="分销比例"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="giveNumber"
                    label="赠送名额"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="giveMoney"
                    label="赠送资金"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="giveScore"
                    label="赠送积分"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="isLimit"
                    label="是否限制"
                    width="180"
                >
                    <template scope='scope'>
                        <div v-if='scope.row.isLimit'>是</div>
                        <div v-if='!scope.row.isLimit'>否</div>
                    </template>
                </el-table-column>

                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="showSelect"
                    label="显示下拉"
                    width="180"
                >
                    <template scope='scope'>
                        <div v-if='scope.row.showSelect'>是</div>
                        <div v-if='!scope.row.showSelect'>否</div>
                    </template>
                </el-table-column>

                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkMppAgentLevel(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editMppAgentLevel(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteMppAgentLevel(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="mppAgentLevelStates[mppAgentLevelState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
                :append-to-body="true"
            >
                <div>
                    <el-form
                        :model="mppAgentLevel"
                        ref="mppAgentLevelForm"
                        :rules="rules"
                        label-width="81px"
                        :inline="true"
                        size="small"
                    >
                        <!-- <el-form-item
                            label="级别名称"
                            prop="agentName"
                        >
                            <el-input
                                size="small"
                                v-model="mppAgentLevel.agentName"
                                :disabled="mppAgentLevelState == 'check'"
                            ></el-input>
                        </el-form-item> -->
                        <el-form-item
                            label="级别名称"
                            prop="agentLevel"
                        >
                            <el-select
                                style="width:175.6px"
                                v-model="mppAgentLevel.agentLevel"
                                size="small"
                                placeholder="请选择"
                                :disabled="mppAgentLevelState == 'check'"
                            >
                                <el-option
                                    v-for="item in agentLevel"
                                    :key="item.key"
                                    :label="item.value"
                                    :value="item.key"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="级别权重"
                            prop="weight"
                        >
                            <el-input
                                style="width:175.6px"
                                size="small"
                                v-model="mppAgentLevel.weight"
                                :disabled="mppAgentLevelState == 'check'"
								placeholder="加权分红时使用"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="代理费用"
                            prop="agentMoney"
                        >
                            <el-input
                                style="width:175.6px"
                                size="small"
                                v-model="mppAgentLevel.agentMoney"
                                :disabled="mppAgentLevelState == 'check'"
								placeholder="申请代理的费用"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="代理比例"
                            prop="agentRatio"
                        >
                            <el-input
                                style="width:175.6px"
                                size="small"
                                v-model="mppAgentLevel.agentRatio"
                                :disabled="mppAgentLevelState == 'check'"
								placeholder="标准商品区域分红"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="积分比例"
                            prop="scoreRatio"
                        >
                            <el-input
                                style="width:175.6px"
                                size="small"
                                v-model="mppAgentLevel.scoreRatio"
                                :disabled="mppAgentLevelState == 'check'"
								placeholder="积分商品区域分红"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="折扣比例"
                            prop="discount"
                        >
                            <el-input
                                style="width:175.6px"
                                size="small"
                                v-model="mppAgentLevel.discount"
                                :disabled="mppAgentLevelState == 'check'"
								placeholder="标准商品折扣"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="积分折扣"
                            prop="scoreDiscount"
                        >
                            <el-input
                                style="width:175.6px"
                                size="small"
                                v-model="mppAgentLevel.scoreDiscount"
                                :disabled="mppAgentLevelState == 'check'"
								placeholder="积分商品折扣"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="分销比例"
                            prop="distributionRatio"
                        >
                            <el-input
                                style="width:175.6px"
                                size="small"
                                v-model="mppAgentLevel.distributionRatio"
                                :disabled="mppAgentLevelState == 'check'"
								placeholder="暂时没有使用"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="赠送名额"
                            prop="giveNumber"
                        >
                            <el-input
                                style="width:175.6px"
                                size="small"
                                v-model="mppAgentLevel.giveNumber"
                                :disabled="mppAgentLevelState == 'check'"
								placeholder="成为代理赠送名额数量"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="赠送资金"
                            prop="giveMoney"
                        >
                            <el-input
                                style="width:175.6px"
                                size="small"
                                v-model="mppAgentLevel.giveMoney"
                                :disabled="mppAgentLevelState == 'check'"
								placeholder="成为代理赠送资金数量"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="赠送积分"
                            prop="giveScore"
                        >
                            <el-input
                                style="width:175.6px"
                                size="small"
                                v-model="mppAgentLevel.giveScore"
                                :disabled="mppAgentLevelState == 'check'"
								placeholder="成为代理赠送积分数量"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="是否限制"
                        >
                            <el-select
                                style="width:175.6px"
                                v-model="mppAgentLevel.isLimit"
                                size="small"
                                placeholder="请选择"
                                :disabled="mppAgentLevelState == 'check'"
                            >
                                <el-option
                                    label="是"
                                    :value="1"
                                ></el-option>
                                <el-option
                                    label="否"
                                    :value="0"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="显示下拉"
                        >
                            <el-select
                                style="width:175.6px"
                                v-model="mppAgentLevel.showSelect"
                                size="small"
                                placeholder="请选择"
                                :disabled="mppAgentLevelState == 'check'"
                            >
                                <el-option
                                    label="是"
                                    :value="1"
                                ></el-option>
                                <el-option
                                    label="否"
                                    :value="0"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="代理logo"
                            prop="agentLogo"
                            label-width="80px"
                        >
                            <el-upload
                                style="width:175.6px"
                                action=""
                                :disabled="mppAgentLevelState == 'check'"
                                class="avatar-uploader"
                                :show-file-list="false"
                                :http-request="uploadImage"
                            >
                                <img
                                    v-if="mppAgentLevel.agentLogo"
                                    :src="mppAgentLevel.agentLogo"
                                    class="avatar"
                                    size="small"
                                />
                                <i
                                    v-else
                                    class="el-icon-plus avatar-uploader-icon"
                                ></i>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="mppAgentLevelState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMppAgentLevelList();
                this.getMppAgentLevelList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMppAgentLevelList();
                this.getMppAgentLevelList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            agentLevel: [],
            queryForm: {
                agentLevel: '', //代理等级
                agentName: '', //代理名称
                agentMoney: '', //代理费
                agentLogo: '', //代理logo
                giveNumber: '', //赠送名额
                giveMoney: '', //赠送资金
                giveScore: '', //赠送积分
                isLimit: '', //是否限制
                showSelect: ''//显示下拉
            },
            srcList: [''],//大图预览
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            mppAgentLevelState: 'add',
            mppAgentLevelStates: {
                add: '新建级别',
                check: '查看级别',
                edit: '修改级别'
            },

            multipleSelection: [],
            mppAgentLevelList: [],
            mppAgentLevel: {
                agentLevel: '', //代理等级
                agentName: '', //代理名称
                weight: '', //代理权重
                agentMoney: '', //代理费
                agentLogo: '', //代理logo
                agentRatio: '', //代理比例
                scoreRatio: '', //积分比例
                discount: '', //代理折扣
                scoreDiscount: '', //积分折扣
                distributionRatio: '', //分销比例
                giveNumber: '', //赠送名额
                giveMoney: '', //赠送资金
                giveScore: '', //赠送积分
                isLimit: '', //是否限制
                showSelect: ''//显示下拉
            },
            btnLoading: false,

            rules: {
                agentLevel: [{ required: true, message: '代理级别不能为空', trigger: 'blur' }],
                agentName: [{ required: true, message: '代理名称不能为空', trigger: 'blur' }],
                weight: [{ required: true, message: '代理权重不能为空', trigger: 'blur' }],
                agentMoney: [{ required: true, message: '代理费用不能为空', trigger: 'blur' }],
                agentRatio: [{ required: true, message: '代理比例不能为空', trigger: 'blur' }],
                scoreRatio: [{ required: true, message: '积分比例不能为空', trigger: 'blur' }],
                discount: [{ required: true, message: '代理折扣不能为空', trigger: 'blur' }],
                scoreDiscount: [{ required: true, message: '积分折扣不能为空', trigger: 'blur' }],
                distributionRatio: [{ required: true, message: '分销比例不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getMppAgentLevelList();
        this.getAgent();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetMppAgentLevelList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.mppAgentLevelList = [];
        },
        resetDialog() {
            this.mppAgentLevelState = 'add';
            this.showDialog = false;
            this.queryForm = {
                agentLevel: '', //代理等级
                agentName: '', //代理名称
                agentMoney: '', //代理费
                agentLogo: '', //代理logo
                giveNumber: '', //赠送名额
                giveMoney: '', //赠送资金
                giveScore: '', //赠送积分
                isLimit: '', //是否限制
                showSelect: ''//显示下拉
            };
            this.getMppAgentLevelList();
        },
        closeDialog() {
            this.showDialog = false;
            this.mppAgentLevel = {
                agentLevel: '', //代理等级
                agentName: '', //代理名称
                weight: '', //代理权重
                agentMoney: '', //代理费
                agentLogo: '', //代理logo
                agentRatio: '', //代理比例
                scoreRatio: '', //积分比例
                discount: '', //代理折扣
                scoreDiscount: '', //积分折扣
                distributionRatio: '', //分销比例
                giveNumber: '', //赠送名额
                giveMoney: '', //赠送资金
                giveScore: '', //赠送积分
                isLimit: '', //是否限制
                showSelect: ''//显示下拉
            };
        },
        submitForm() {
            if (this.mppAgentLevelState == 'add') {
                this.$refs.mppAgentLevelForm.validate((valid) => {
                    if (valid) {
                        post(`/mpp/mppagentlevel/add`, { ...this.mppAgentLevel }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppAgentLevelList();
                                this.resetDialog();
                                this.getMppAgentLevelList();
                            }
                        });
                    }
                });
            } else if (this.mppAgentLevelState == 'edit') {
                this.$refs.mppAgentLevelForm.validate((valid) => {
                    if (valid) {
                        post(`/mpp/mppagentlevel/edit`, { ...this.mppAgentLevel }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppAgentLevelList();
                                this.resetDialog();
                                this.getMppAgentLevelList();
                            }
                        });
                    }
                });
            }
        },
        addMppAgentLevel() {
            this.mppAgentLevel = {
                agentLevel: '', //代理等级
                agentName: '', //代理名称
                weight: '', //代理权重
                agentMoney: '', //代理费
                agentLogo: '', //代理logo
                agentRatio: '', //代理比例
                scoreRatio: '', //积分比例
                discount: '', //代理折扣
                scoreDiscount: '', //积分折扣
                distributionRatio: '', //分销比例
                giveNumber: '', //赠送名额
                giveMoney: '', //赠送资金
                giveScore: '', //赠送积分
                isLimit: 1, //是否限制
                showSelect: 1//显示下拉
            },
                this.showDialog = true;
            this.mppAgentLevelState = 'add';
        },
        checkMppAgentLevel(mppAgentLevelId) {
            this.currentMppAgentLevelId = mppAgentLevelId;

            this.getMppAgentLevelById();
            this.showDialog = true;
            this.mppAgentLevelState = 'check';
        },
        editMppAgentLevel(mppAgentLevelId) {
            if (mppAgentLevelId) {
                this.currentMppAgentLevelId = mppAgentLevelId;
                this.getMppAgentLevelById();
            } else {
                this.mppAgentLevel = { ...this.mppAgentLevel, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.mppAgentLevelState = 'edit';
        },
        deleteMppAgentLevel(mppAgentLevelId) {
            let ids = '';
            if (mppAgentLevelId) {
                ids = mppAgentLevelId;
            } else {
                ids = this.multipleSelection.map((mppAgentLevel) => mppAgentLevel.id).join(',');
            }
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/mppagentlevel/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMppAgentLevelList();
                            this.getMppAgentLevelList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMppAgentLevelList() {
            this.resetMppAgentLevelList();
            this.getMppAgentLevelList();
        },
        getMppAgentLevelList(query = {}) {
            this.loading = true;
            get(`/mpp/mppagentlevel/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.mppAgentLevelList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getMppAgentLevelById() {
            get(`/mpp/mppagentlevel/get`, { id: this.currentMppAgentLevelId }).then((res) => {
                if (res.success) {
                    this.mppAgentLevel = { ...this.mppAgentLevel, ...res.mppAgentLevel };
                }
            });
        },
        /**
         * 导出信息
         */
        exportMppAgentLevelList() {
            //this.btnLoading = true;
            exprotExcel(`/mpp/mppagentlevel/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/mppagentlevel/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            importDate(`/mpp/mppagentlevel/importData`, formData);
            this.refreshMppAgentLevelList();
        },
        handleSelectionChange(value) {
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMppAgentLevelList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMppAgentLevelList();
        },
        getAgent() {
            get(`/mpp/utils/getEnum`, { enumType: 'agent_level' }).then((res) => {
                if (res.success) {
                    this.agentLevel = res.enumList;
                }
            });
        },
        getLevelString(key) {
            for (const index in this.agentLevel) {
                if (this.agentLevel[index].key == key) {
                    return this.agentLevel[index].value;
                }
            }
        },
        uploadImage(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!types.includes(file.type)) {
                this.$message({
                    message: '只能上传图片格式的文件，png.jpg或者jpeg',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload('/mpp/image/upload', formData).then((res) => {
                console.log(res);
                if (res.success) {
                    this.mppAgentLevel.agentLogo = res.url;
                }
            });
        },
        updateSrcList(src) {
            this.srcList[0] = src;
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

::v-deep .el-upload--text {
    width: 175.6px;
    height: 175.6px;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
